export default __webpack_public_path__ + "static/media/home-IEEELogo.aebb3372.svg";